import type { IntlShape } from "react-intl";

import type { SupportedCountry } from "../components/interface";

export interface ValidationResult {
  isValid: boolean;
  error?: {
    message: string;
    title: string;
  };
}

export interface SignerValidationByCountry {
  validate: (_signers: unknown[], _intl: IntlShape) => ValidationResult;
}

const createValidationSuccess = (): ValidationResult => {
  return {
    isValid: true,
  };
};

export const signerValidationByCountry: Partial<Record<SupportedCountry, SignerValidationByCountry>> = {
  AU: { validate: createValidationSuccess },
};
